import usStates5m4326Topo from 'json/usStates5m4326Topo.json';
import * as topojson from 'topojson-client';
import Highcharts from 'highcharts';
import Map from 'highcharts/modules/map.src';

Map(Highcharts);

(function() {

  var $self = this;
  $self.ProjectsAndPartnerships          = $self.ProjectsAndPartnerships          || {};
  $self.ProjectsAndPartnerships.projects = $self.ProjectsAndPartnerships.projects || {};

  $self.ProjectsAndPartnerships.projects.initiatives = (function() {
    var pub = {};

    pub.init = function(params) {
      const projectIds = params.projectIds;
      const stateFeatures = topojson.feature(usStates5m4326Topo, usStates5m4326Topo.objects.usStates5m4326).features;

      _renderMaps(projectIds, stateFeatures);
    };

    function _renderMaps(projectIds, stateFeatures) {
      projectIds.forEach((projectId) => {
        _drawProject(projectId, stateFeatures);
      });
    }

    function _adjustClippedLabels() {
      var chart = this;
      chart.series.forEach((series) => {
        series.points.forEach((point) => {
          if (point.dataLabel) {
            let newX;

            // If the label is rendering outside of the viewport on the left,
            // shift it to the left-most visible point.
            if (point.dataLabel.x < 0) {
              newX = 0;
            } else {
              // If the data label overflows to the right, try shifting the
              // label so it will fit within the width.
              const labelBBox = point.dataLabel.getBBox();
              if (point.dataLabel.x + labelBBox.width > chart.chartWidth) {
                newX = chart.chartWidth - labelBBox.width;
                if (newX < 0) {
                  newX = 0;
                }
              }
            }

            if (newX !== undefined) {
              point.dataLabel.translate(newX, point.dataLabel.y);
            }
          }
        });
      });
    }

    function _drawProject(projectId, stateFeatures) {
      const container = document.getElementById(`cc-map-item-${projectId}`);
      const state = container.dataset.state;
      const city = container.dataset.city;
      const latitude = parseFloat(container.dataset.latitude);
      const longitude = parseFloat(container.dataset.longitude);

      const stateGeojson = stateFeatures.find((feature) => feature.properties.STUSPS === state);

      let label = state;
      if (city) {
        label = `${city}, ${label}`;
      }

      const chart = Highcharts.mapChart(`cc-map-item-${projectId}`, {
        chart: {
          map: [stateGeojson],
          animation: false,
          // Enough spacing so if point renders on exact edge, it can still
          // show the full circle (rather than the circle being clipped).
          spacing: [3, 3, 3, 3],
          backgroundColor: 'transparent',
          style: {
            fontFamily: 'inherit',
          },
          events: {
            load: _adjustClippedLabels,
            redraw: _adjustClippedLabels
          },
        },

        mapView: {
          // Better rendering projections for the EPSG:4326 GeoJSON data so the
          // rendered shapes look more natural.
          projection: {
            name: 'LambertConformalConic',
          },
        },

        credits: {
          enabled: false,
        },

        tooltip: {
          enabled: false,
        },

        legend: {
          enabled: false,
        },

        title: {
          text: undefined,
        },

        series: [
          {
            type: 'map',
            borderWidth: 1.5,
            borderColor: '#ada396',
            nullColor: '#d3c6b6',
          },
          {
            type: 'mappoint',
            animation: false,
            data: [{
              color: '#000',
              name: label,
              geometry: {
                type: 'Point',
                coordinates: [
                  longitude,
                  latitude,
                ]
              },
            }],
            dataLabels: {
              style: {
                color: '#333',
                fontWeight: 'normal',
                fontSize: '13px',
              },
            },
            marker: {
              states: {
                hover: {
                  enabled: false,
                },
              },
            },
          },
        ],
      });
    }

    return pub;
  })();



}).call(CC);
